export const UPDATE_QUESTION_BENCHMARKS = "UPDATE_QUESTION_BENCHMARKS";
export const CONTENT_SUBTYPE_FTRE_QUESTION_SUCCESS = 'CONTENT_SUBTYPE_FTRE_QUESTION_SUCCESS';
export const CONTENT_SUBTYPE_FTRE_TESTPAPERS_SUCCESS = 'CONTENT_SUBTYPE_FTRE_TESTPAPERS_SUCCESS';
export const CONTENT_SUBTYPE_AITS_QUESTION_SUCCESS = 'CONTENT_SUBTYPE_AITS_QUESTION_SUCCESS';
export const CONTENT_SUBTYPE_AITS_TESTPAPERS_SUCCESS = 'CONTENT_SUBTYPE_AITS_TESTPAPERS_SUCCESS';
export const CONTENT_SUBTYPE_NATIONAL_LEVET_QUESTION_SUCCESS = 'CONTENT_SUBTYPE_NATIONAL_LEVET_QUESTION_SUCCESS';
export const CONTENT_SUBTYPE_NATIONAL_LEVEL_TESTPAPERS_SUCCESS = 'CONTENT_SUBTYPE_NATIONAL_LEVEL_TESTPAPERS_SUCCESS';
